import StickyFooter from './StickyFooter'
import Flex from './StickyFooterFlex'

StickyFooter.Flex = Flex

export default StickyFooter
